<template>
  <v-layout column>
    <v-layout row justify-end v-if="canChangeAccessory">
      <v-btn
        @click="$emit('addAccessory', 'create')"
        x-small
        text
        icon
        color="accent"
        :disabled="disabled"
      >
        <v-icon>add_circle</v-icon>
      </v-btn>
    </v-layout>
    <accessories-and-others-table
      :can-change-accessory="canChangeAccessory"
      :accessories="accessoriesSelected"
      :disabled="disabled"
      @delete-item="$emit('delete-item', $event)"
      @edit-item="$emit('edit-item', $event)"
    />
  </v-layout>
</template>

<script>
import AccessoriesAndOthersTable from "@/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersTable";
export default {
  name: "AccessoriesAndOthersList",

  components: { AccessoriesAndOthersTable },

  props: {
    accessoriesSelected: Array,

    disabled: {
      type: Boolean,
      default: false
    },

    canChangeAccessory: {
      type: Boolean,
      default: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersList.vue